<script>
  import ClampText from "$lib/Elements/ClampText.svelte";
  import CopyButton from "$lib/Elements/CopyButton.svelte";

  export let key;
  export let value;
</script>

<div class="flex items-start gap-2">
  <span class="shrink-0 text-purple-400">{key}:</span>
  <div
    class="group flex min-w-0 flex-1 items-start gap-2 rounded px-2 hover:ring-1 hover:ring-inset hover:ring-white/10"
  >
    <div class="min-w-0 flex-1">
      <ClampText>
        <span class="whitespace-pre-wrap break-words text-gray-300">{value}</span>
      </ClampText>
    </div>
    <CopyButton
      text={value}
      class="shrink-0 text-content-subtle opacity-0 transition-opacity group-hover:opacity-100 focus:opacity-100"
    />
  </div>
</div>
